module.exports = __webpack_public_path__ + "img/ueber_mich_breiter.2675dadd.jpg";